import {useMutation} from '@apollo/react-hooks';

import type {
    ShortenedUrlDomainSet as FormsSchedulerDomainSetMutation,
    ShortenedUrlDomainSetVariables as FormsSchedulerDomainSetMutationVariables,
    ShortenedUrlDomainSetInput,
} from 'nutshell-graphql-types';

import SET_DOMAIN from '../mutations/shortened-url-domain-set.graphql';

export function useSetFormsSchedulerDomain(): {
    setFormsSchedulerDomain: (arg1: ShortenedUrlDomainSetInput) => Promise<any>;
} {
    const [setFormsSchedulerDomain] = useMutation<
        FormsSchedulerDomainSetMutation,
        FormsSchedulerDomainSetMutationVariables
    >(SET_DOMAIN);

    return {
        setFormsSchedulerDomain: (input: ShortenedUrlDomainSetInput) =>
            setFormsSchedulerDomain({
                variables: {input},
            }),
    };
}
